/* eslint-disable jira/filename-case */

import { defineMessage } from '@jira/platform__react-intl';
import {
	TAILORED_ONBOARDING_SUMMARY,
	TAILORED_ONBOARDING_LIST,
	TAILORED_ONBOARDING_TIMELINE,
	TAILORED_ONBOARDING_PAGES,
	TAILORED_ONBOARDING_FORM,
	TAILORED_ONBOARDING_INVITE,
	TAILORED_ONBOARDING_BOARD,
	TAILORED_ONBOARDING_CALENDAR,
	TAILORED_ONBOARDING_BACKLOG,
	TAILORED_ONBOARDING_CODE,
	JWM_CREATE_PROJECT_TASK,
	JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES,
	JWM_BUILD_FORM_TASK,
	JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK,
	JWM_SUMMARY_AND_REPORTS_TASK,
	JWM_TRELLO_CROSSFLOW_TASK_IMPORT,
} from '../../../../common/constants.tsx';
import type { Cards, TaskList } from '../../../../common/types.tsx';
import { TAILORED_ONBOARDING_SINGLE_CONFIG } from './shared-config-new.tsx';

const rootTitle = defineMessage({
	id: 'software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate',
	defaultMessage: 'Quickstart',
	description: 'Initial title of the Quickstart',
});

export const TAILORED_ONBOARDING_WITH_SINGLE_CONFIG_TASK_LIST: TaskList = Object.freeze({
	root: {
		title: rootTitle,
		items: [
			TAILORED_ONBOARDING_SUMMARY,
			TAILORED_ONBOARDING_CALENDAR,
			TAILORED_ONBOARDING_LIST,
			TAILORED_ONBOARDING_TIMELINE,
			TAILORED_ONBOARDING_PAGES,
			TAILORED_ONBOARDING_FORM,
			TAILORED_ONBOARDING_INVITE,
			TAILORED_ONBOARDING_BOARD,
			TAILORED_ONBOARDING_BACKLOG,
			TAILORED_ONBOARDING_CODE,
		],
	},
});

export const TAILORED_ONBOARDING_WITH_SINGLE_CONFIG: {
	readonly taskList: TaskList;
	readonly taskVariants: Cards;
} = {
	taskList: TAILORED_ONBOARDING_WITH_SINGLE_CONFIG_TASK_LIST,
	taskVariants: TAILORED_ONBOARDING_SINGLE_CONFIG,
} as const;

export const BUSINESS_TASK_LIST: TaskList = Object.freeze({
	root: {
		title: rootTitle,
		items: [
			// JWM Trello Crossflow Tasks
			JWM_CREATE_PROJECT_TASK,
			JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES,
			JWM_BUILD_FORM_TASK,
			JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK,
			JWM_SUMMARY_AND_REPORTS_TASK,
			JWM_TRELLO_CROSSFLOW_TASK_IMPORT,
			// JSW Tailored Onboarding Tasks
			TAILORED_ONBOARDING_SUMMARY,
			TAILORED_ONBOARDING_LIST,
			TAILORED_ONBOARDING_TIMELINE,
			TAILORED_ONBOARDING_BOARD,
			TAILORED_ONBOARDING_CALENDAR,
			TAILORED_ONBOARDING_PAGES,
			TAILORED_ONBOARDING_FORM,
			TAILORED_ONBOARDING_INVITE,
		],
	},
});

export const TAILORED_ONBOARDING_BUSINESS: {
	readonly taskList: TaskList;
} = {
	taskList: BUSINESS_TASK_LIST,
} as const;
